'use strict';

var React = require('react');

var SvgMobilePlusMajor = function SvgMobilePlusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6.75a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5Z"
  }));
};
SvgMobilePlusMajor.displayName = "MobilePlusMajor";

exports.SvgMobilePlusMajor = SvgMobilePlusMajor;
